import { IImage, IImageType } from 'base/interfaces/product';
import { transImageSrc } from 'base/utils/trans-path';

const placeholderUrl = 'asset/width-500/picture/10c9cf377deb0a64c729fecbb6a4baab.png'

// 返回图片链接
const getPicUrl = (url: string | string[]): string => {
    let newUrl = Array.isArray(url) ? url[0] : url;
    if (!newUrl || newUrl.length === 0) {
        newUrl = placeholderUrl;
    }
    return newUrl;
};

// 获取是主图的数据项
export const getImagesTargetTypeItem = (images: IImage[], imageType?: IImageType) => {
    if (!images || !images.length) {
        return void 0
    }
    const _type = imageType || 'isMain'
    return images.find(image => !!image[_type]);
}

// 将主图放置第一位
export const mainPicFirstHandle = (images?: IImage[]): IImage[] => {
    if (!images || !images.length) {
        return []
    }
    let _images = images
    const mainIndex = images.findIndex(image => image.isMain)

    if (mainIndex != -1) {
        const _mainItem = _images.splice(mainIndex, 1)
        _images.unshift(_mainItem[0])
    }
    return _images
}

/**
 * 获取指定 variantId 图片列表
 * 没有指定id 返回 type == "0" 的商品图列表
 */
export const getVariantImagesList = (images: IImage[] = [], productVariantId?: string): IImage[] => {
    let _images = images.filter((item) => item.productVariantId == productVariantId)

    if (!_images.length) {
        _images = images.filter((item) => Number(item.type) === 0)
    }

    return _images
}

// 获取主图对象
export const getMainImage = (images: IImage[], productVariantId?: string): IImage | undefined => {
    let _images = images;
    if (productVariantId) {
        _images = getVariantImagesList(images, productVariantId)
    }
    const item = getImagesTargetTypeItem(_images)
    return item || _images[0] || images[0];
};
// 获取主图src
export const getMainPicUrl = (images: IImage[], productVariantId?: string): string => {
    return getMainImage(images, productVariantId)?.picLink || '';
};


export const getTargetImage =  (
    images: IImage[],
    productVariantId?: string,
    type?: IImageType
): IImage | undefined => {
    let _images = images;
    if (productVariantId) {
        _images = getVariantImagesList(images, productVariantId)
    }
    const item = getImagesTargetTypeItem(_images, type)
    if (type == 'isMain') {
        // 主图兼容返回
        return item || _images[0] || images[0];
    }
    return item
};

// 创建Image对象，图片预下载
export const loadImage = (url: string, callback?: (img: HTMLImageElement) => void) => {
    let img = new Image()
    img.onload = function () {
        img.onload = null
        callback?.(img)
    }
    img.onerror = function () {
        img.onerror = null
        img.src = transImageSrc(placeholderUrl)
    }
    img.src = url;
}

export const loadImages = (urls: string[], callback?: () => void) => {
    if (!urls?.length) {
        return
    }
    urls?.forEach((url) => {
        loadImage(url)
    })
    callback?.()
}